import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { CoursesService } from 'src/app/Services/Courses.service';
import * as Player from "@vimeo/player/dist/player.js";
import { environment } from 'src/environments/environment';
import {Router} from '@angular/router';
declare var $;

@Component({
  selector: 'app-lessonbox',
  templateUrl: './lesson-box.component.html',
  styleUrls: ['./lesson-box.component.scss']
})
export class LessonBoxComponent implements OnInit {
  @ViewChild('closeModal', {static: false}) closeModal: ElementRef<HTMLInputElement>;

  @Input() lesson;
  @Input() course;
  @Input() openBox  = false;
  videoPicture;
  videoFrame;
  videoId;
  videoLoaded = false;
  isLessonBoxShown = false;

  @Output() boxExpanded = new EventEmitter<string>();
  @Output() statusLesson = new EventEmitter<string>();
  constructor(private courseService: CoursesService, private router: Router) { }

  ngOnInit() {
    this.getThumb();
    if(this.openBox) {
      this.lesson.expand = true;
    }
  }

  getThumb() {
    if (this.lesson.video)
      this.courseService.getVideoData(this.lesson.video)
        .then((data) => {
          console.log("data of!", data)
          this.videoPicture = data.body.pictures.sizes[3].link;
          this.videoId = data.body.uri.replace('/videos/', '');
        })
        .catch((error) => { console.log(error) })
  }

  toggleVisibility() {
    if(!this.lesson.expand) {
      this.boxExpanded.emit(this.lesson.id)
    }else {
      this.lesson.expand = false;
    }
  }

  initializeVideoPlayer() {
    let player = new Player(this.videoId, { id: this.videoId, responsive: true });


    player.on('ended', () => {
      this.changeLessonStatus(true);
    });

    player.on('loaded', () => {
      this.videoLoaded = true;
    });

    $("#modal-" + this.videoId).on("hide.bs.modal", () => {
      player.unload()
      this.videoLoaded = false;
    });

  }

  openVideoModal() {
    this.videoLoaded = true;

    setTimeout(() => {
      this.initializeVideoPlayer()
    }, 200);
  }

  changeLessonStatus(status) {
    console.log('test change status')
    this.courseService.changeLessonStatus(status, this.lesson.id,this.course.id).then((data) => {
      this.lesson.approved = status;
      this.lesson.expand = false;
      this.isLessonBoxShown = true;
      this.statusLesson.emit(status);

      if(this.closeModal){
            this.closeModal.nativeElement.click()
      }
     /*  console.log('DATA',data);
      if (data.status === 'finished') {
        if(data.extra !== null) {
          this.router.navigateByUrl('/courses/review/' + this.lesson.course + '?extra=' + data.extra.id);
        }else{
          this.router.navigateByUrl('/courses/review/' + this.lesson.course );
        }

      } else if (data.extra !== null) {
        this.router.navigateByUrl('/courses/extra/' + data.extra.id);
      } */

    }).catch((error) => {
      console.log(error);
    })
  }

  get attachmentLink() {
    return environment.baseUrl + this.lesson.pdf;
  }

}
